/**
 * Copy the provided text to clipboard
 * @param {string} text
 *
 */
export default function copyToClipboard(text: string) {
  navigator.clipboard.writeText(text)
}
